import { Alert, AlertTitle, Button, Link } from '@mui/material';
import FormattedMessage from 'features/i18n/FormattedMessage';
import { useIsOnSalesAssistedPlan } from 'features/pricing/useIsOnSalesAssistedPlan';
import styled from 'styled-components';
import useTr from 'utils/hooks/useTr';

export const UserIsOnSalesAssistedPlanBanner = () => {
  const translate = useTr();

  const isOnSalesAssistedPlan = useIsOnSalesAssistedPlan();
  if (!isOnSalesAssistedPlan) {
    return null;
  }

  return (
    <BannersBox>
      <Alert
        severity="info"
        variant="filled"
        action={
          <Button
            component={Link}
            variant="outlined"
            color="primary"
            size="small"
            href={translate('sales_assisted.banner.link_contact_sales')}
          >
            <FormattedMessage id="sales_assisted.banner.cta_contact_sales" />
          </Button>
        }
      >
        <AlertTitle>
          <FormattedMessage id="sales_assisted.banner.title" />
        </AlertTitle>

        <FormattedMessage id="sales_assisted.banner.description" />
      </Alert>
    </BannersBox>
  );
};

const BannersBox = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.three};
`;
